import React from 'react'
import Header from '../repeat/Header'
import Footer from '../repeat/Footer'
import Navigation from './navigation'
const Department = () => {
  return (
    <div>
        <Header/>
        <Navigation/>
       
        <Footer/>
     </div>
  )
}

export default Department
